import { Box, makeStyles, Theme, Typography } from "@material-ui/core"
import React from "react"
import { FormattedMessage } from "react-intl"
import usePlatform from "../hooks/usePlatform"
import { Locale } from "../locale"
import programmingLanguageIcons from "../assets/images/service/service_programming_language_icons.png"
import programmingLanguageIconsMo from "../assets/images/service/service_programming_language_icons_mo.png"

interface StyleProps {
  isMobile: boolean
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  root: {
    backgroundColor: "#FFFFFF",
    padding: "40px 20px 52px 20px",
    [theme.breakpoints.up("md")]: {
      padding: "96px 20px 130px 20px",
    },
  },
  title: {
    marginBottom: "16px",
    "& > h2": {
      letterSpacing: "-1px",
      fontWeight: 700,
      fontSize: "22px",
      lineHeight: "33px",
    },
    [theme.breakpoints.up("md")]: {
      "& > h2": {
        fontSize: "40px",
        lineHeight: "56px",
        marginBottom: "24px",
      },
      "& .space": {
        marginLeft: "10px",
      },
    },
  },
  description: {
    marginBottom: "40px",
    "& p": {
      letterSpacing: "-1px",
      fontWeight: 400,
      color: "rgba(0, 0, 0, 0.87)",
      fontSize: "14px",
      lineHeight: "20px",
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: "56px",
      "& p": {
        fontSize: "20px",
        lineHeight: "32px",
      },
      "& .space": {
        marginLeft: "6px",
      },
    },
  },
  imgWrapper: {
    maxWidth: ({ isMobile }) => (isMobile ? "332px" : "1040px"),
    "& img": {
      width: "100%",
    },
  },
}))

export default function SDKIntegration() {
  const { isMobile } = usePlatform()
  const { lang } = Locale.getDefault()
  const classes = useStyles({ isMobile })

  return (
    <Box display="flex" flexDirection="column" alignItems="center" width="100%" className={classes.root}>
      <Box display="flex" flexDirection={isMobile ? "column" : "row"} className={classes.title}>
        <Typography variant="h2">
          <FormattedMessage id="service_sdk_integration_title" />
        </Typography>
        {lang === "en" && (
          <Typography variant="h2" className="space">
            <FormattedMessage id="service_sdk_integration_title_2" />
          </Typography>
        )}
      </Box>
      <Box display="flex" flexDirection="column" alignItems="center" className={classes.description}>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"} alignItems="center">
          <Typography variant="body1">
            <FormattedMessage id="service_sdk_integration_desc_1" />
          </Typography>
          {lang === "en" && (
            <Typography variant="body1" className="space">
              <FormattedMessage id="service_sdk_integration_desc_1_2" />
            </Typography>
          )}
        </Box>
        <Box display="flex" flexDirection={isMobile ? "column" : "row"} alignItems="center">
          <Typography variant="body1">
            <FormattedMessage id="service_sdk_integration_desc_2" />
          </Typography>
          {lang === "en" && (
            <Typography variant="body1" className="space">
              <FormattedMessage id="service_sdk_integration_desc_2_2" />
            </Typography>
          )}
        </Box>
      </Box>
      <div className={classes.imgWrapper}>
        <img src={isMobile ? programmingLanguageIconsMo : programmingLanguageIcons} />
      </div>
    </Box>
  )
}
